import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "visualiser-controls-main" }
const _hoisted_2 = { class: "visualiser-controls-main-label-sm" }
const _hoisted_3 = { class: "visualiser-controls-main-info" }
const _hoisted_4 = { class: "visualiser-controls-main-grid" }
const _hoisted_5 = ["onClick"]

import {computed} from 'vue';
import {useStore} from '../store';
import {FrameColour} from '../types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ControlFrame',
  setup(__props) {

const store = useStore();

const tFrameColour = computed(() => VisualiserConfig.locale === 'au'
    ? 'Frame colour'
    : 'Frame color');

const tColour = computed(() => VisualiserConfig.locale === 'au'
    ? 'Colour'
    : 'Color');

const options = computed(() =>
    VisualiserConfig.locale === 'au'
        ? [
            {value: FrameColour.Black, label: 'Black', swatch: '#000'},
            {value: FrameColour.Monument, label: 'Monument', swatch: '#434343'},
            {value: FrameColour.WoodlandGrey, label: 'Woodland Grey', swatch: '#656c6d'},
            {value: FrameColour.Paperbark, label: 'Paperbark', swatch: '#decbae'},
            {value: FrameColour.ClassicCream, label: 'Classic Cream', swatch: '#f0e5bf'},
            {value: FrameColour.SurfMist, label: 'Surf Mist', swatch: '#d6d6cc'},
            {value: FrameColour.PureWhite, label: 'Pure White', swatch: '#fff'},
        ]
        : [
            {value: FrameColour.Black, label: 'Black', swatch: '#000'},
            {value: FrameColour.Bronze, label: 'Bronze', swatch: '#554e52'},
            {value: FrameColour.WoodlandGrey, label: 'Woodland Gray', swatch: '#656c6d'},
            {value: FrameColour.Paperbark, label: 'Paperbark', swatch: '#decbae'},
            {value: FrameColour.PureWhite, label: 'Pure White', swatch: '#fff'},
        ]);

const currentLabel = computed(() => options.value.find(o => o.value === store.frameColour)?.label);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(tFrameColour.value) + ": " + _toDisplayString(currentLabel.value), 1 /* TEXT */),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "visualiser-controls-main-label-lg" }, "Frame", -1 /* HOISTED */)),
    _createElementVNode("div", _hoisted_3, _toDisplayString(tColour.value) + " : " + _toDisplayString(currentLabel.value), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, ({value, swatch}) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(['visualiser-controls-main-grid-option', _unref(store).frameColour === value && 'active']),
          onClick: ($event: any) => (_unref(store).frameColour = value)
        }, [
          _createElementVNode("div", {
            style: _normalizeStyle({['background-color']: swatch}),
            class: "visualiser-controls-main-grid-swatch"
          }, null, 4 /* STYLE */)
        ], 10 /* CLASS, PROPS */, _hoisted_5))
      }), 256 /* UNKEYED_FRAGMENT */))
    ])
  ]))
}
}

})